module.exports = __webpack_public_path__ + "img/boatmax30.e9040a4a.png";